import { render, staticRenderFns } from "./aiLecturePage.vue?vue&type=template&id=5ce3bb76&scoped=true&"
import script from "./aiLecturePage.vue?vue&type=script&lang=js&"
export * from "./aiLecturePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce3bb76",
  null
  
)

export default component.exports